/**
 * Matter Roles Types
 *
 * Type definitions for matter role assignments
 */

export enum MatterRole {
  ACTING_SOLICITOR = 'acting_solicitor',
  ASSISTING_MEMBER = 'assisting_member'
}

export enum MatterRoleText {
  ACTING_SOLICITOR = 'Acting solicitor',
  ASSISTING_MEMBER = 'Assisting Team Member'
}

export interface AssignRoleRequest {
  matterId: number;
  userId: number;
  role: MatterRole;
}

export interface AssignRoleResponse {
  message: string;
}
